module.exports = __webpack_public_path__ + "static/marco-logo-43189a8be3a249c271f09072e922f5da.svg";